<template>
  <div class="head ">
    <div class="middle">
      <div class="head-left">
        <div class="head-left1">
          <img src="../../../assets/img/shouye/sche.png">
          <em>{{this.$ExhibitionDate()}}</em>
        </div>
        <div class="head-left2">
          <img src="../../../assets/img/shouye/address.png">
          <em>{{this.$MyConstant('Api_CONSTANT.SizeConfig.exhibition_address_'+MY_CONSTANT.sqlWhereLang) }}</em>
        </div>
      </div>
      <div class="head-right">
        <div class="tupian">
          <div class="hk" style="display: none;">
            <input type="search" name="headersousuokeyword" id="" v-model="keyword" :placeholder="this.$MyConstant('Lang.searchNew')" value="">

              <img @click="headersousuokeyword();" src="../../../assets/img/shouye/search.png">

          </div>
          <img id="sea" src="../../../assets/img/shouye/search.png">
          <custom-link to="/SinglePage/monomial/contact" class="lianxi">
            <img src="../../../assets/img/shouye/lianxi.png">
          </custom-link>

          <div class="yonghu" v-if="this.$cookies.isKey('Cookie')">

            <p>{{this.$MyConstant('Lang.welcome')}}！
<!--              this.$empty(-->
              <custom-link v-if="MY_CONSTANT.sqlWhereLang=='cn'" to="/UserEdit">{{!this.$empty(this.$getCookie('cp_name'))?this.$getCookie('cp_name'):this.$getCookie('cp_en_name')}}
              </custom-link>
              <custom-link v-else to="/UserEdit">{{!this.$empty(this.$getCookie('cp_en_name'))?this.$getCookie('cp_en_name'):this.$getCookie('cp_name')}}
              </custom-link>
              ,
            </p>
            <p class="quit">
              <custom-link to="/UserLogout">
                {{MY_CONSTANT.Lang.exit}}</custom-link>
            </p>
          </div>

        </div>
        <div class="select_contain">
          <div class="select_item clearfix left">
            <div class="select_module_con left">
              <div class="select_result">
                <span>{{MY_CONSTANT.sqlWhereLang=='cn'?'中文':'EN'}}</span>
                <div id="triangle1" class="triangle">
                  <img src="../../../assets/img/shouye/xiala.png">
                </div>
                <div id="triangle2" class="triangle" style="display:none">
                  <img src="../../../assets/img/shouye/xiala2.png">
                </div>
              </div>
              <ul v-if="MY_CONSTANT.sqlWhereLang=='cn'">
                <a  @click="setLang('zh-cn')"><li>中文</li></a>
                <a   @click="setLang('en-us')"><li> EN</li></a>
              </ul>
              <ul v-if="MY_CONSTANT.sqlWhereLang=='en'">
                <a  @click="setLang('en-us')"><li> EN</li></a>
                <a  @click="setLang('zh-cn')"><li>中文</li></a>
              </ul>
            </div>
          </div>
        </div>
         <custom-link v-if="!this.$cookies.isKey('Cookie')" to="/UserLogin" class="login">
          <p>{{MY_CONSTANT.Lang.login}}</p>
        </custom-link>
      </div>
    </div>
  </div>

  <div class="head-menu ">
    <div class="head-menu-center" >

      <div class="log">
        <custom-link to="/">
          <img src="../../../assets/img/shouye/logo.png">
        </custom-link>
      </div>

      <div class="log-right">
        <ul>
          <li :class="this.$route.path == '/'+MY_CONSTANT.setApiLang+s.url? 'log-right1 newscolor' : 'log-right1'"  v-for="(s,index) in menuItems">
            <custom-link class="dianji"  :to="s.url">
              {{ s['name_'+MY_CONSTANT.sqlWhereLang] }}
            </custom-link>

            <div class="menu_a">
              <ul>
                <li v-for="(ss,index) in s.list"> <custom-link :to="ss.url">{{ ss['name_'+MY_CONSTANT.sqlWhereLang] }}</custom-link></li>
              </ul>
            </div>

          </li>
        </ul>
      </div>

    </div>
  </div>
  <div style="margin-top: 182px;"></div>
</template>
<script>
export default {


  data () {
    return {
      menuItems:this.$MyConstant('Api_CONSTANT.menu.PublicMenu'),
      keyword:'',
      currentYear:null,
      currentMonth:null
    }
  }
  ,
  created() {
    this.setHeader()
    const date = new Date(this.$MyConstant('Api_CONSTANT.SizeConfig.ini_cpse_date').split(" ")[0]);
    this.currentYear = date.getFullYear();
    this.currentMonth= date.getMonth() + 1;


    // console.log(this.$MyConstant('Api_CONSTANT.menu.PublicMenu'))

  },

  methods: {
    // setLanguage(lang){
    //
    //   localStorage.setItem("Accept-Language",lang);
    //   window.location.reload();
    // },
    headersousuokeyword(){

     if(!this.$empty(this.keyword))  this.$router.push('/'+this.MY_CONSTANT.setApiLang+'/News?keyword='+this.keyword)

      // this.$router.push();
    }
  },
  mounted() {


    $(document).click(function(){
      $(".select_module_con ul").slideUp();
    })
    var module=$(".select_result");
    module.click(function(e){
      e.stopPropagation();
      var ul=$(this).next();
      ul.stop().slideToggle();
      ul.children().click(function(e){
        e.stopPropagation();
        $(this).parent().prev().children("span").text($(this).text());
        ul.stop().slideUp();
      })
    })

    $("#sea").click(function(){

      $(".tupian .hk").css("display","block")
      $("#sea").css("display","none")
      $(".yonghu").css("display","none")
    })

  }
}
</script>
